import { gql } from "@apollo/client";

export const ORGANIZATION_EVENTS = gql`
  query OrganizationEvents(
    $organizationId: ID!
    $status: EventStatus
    $limit: Int
    $offset: Int
  ) {
    organizationEvents(
      organizationId: $organizationId
      status: $status
      limit: $limit
      offset: $offset
    ) {
      items {
        _id
        creatorId
        name
        description
        startDate
        endDate
        startTime
        endTime
        location {
          address
          city
          country
          isVirtual
          meetingLink
        }
        photoUrl
        accessibility
        status
        organizationId
        isActive
        createdAt
        updatedAt
        participantCount
        recurrence {
          enabled
          intervalValue
          intervalUnit
        }
        sourceTemplateId
        nextOccurrenceDate
        isStarted
        isEnded
        daysUntilStart
        creator {
          _id
          firstName
          lastName
        }
      }
      totalCount
      hasMore
    }
  }
`;

export const CREATE_EVENT = gql`
  mutation CreateEvent($input: CreateEventInput!) {
    createEvent(input: $input) {
      _id
      name
      description
      startDate
      endDate
      startTime
      endTime
      location {
        address
        city
        country
        isVirtual
        meetingLink
      }
      photoUrl
      accessibility
      status
      organizationId
      participantCount
      recurrence {
        enabled
        intervalValue
        intervalUnit
      }
      createdAt
    }
  }
`;

export const UPDATE_EVENT = gql`
  mutation UpdateEvent($id: ID!, $input: UpdateEventInput!) {
    updateEvent(id: $id, input: $input) {
      _id
      name
      description
      startDate
      endDate
      startTime
      endTime
      location {
        address
        city
        country
        isVirtual
        meetingLink
      }
      photoUrl
      accessibility
      status
      organizationId
      participantCount
      recurrence {
        enabled
        intervalValue
        intervalUnit
      }
      updatedAt
    }
  }
`;

export const PUBLISH_EVENT = gql`
  mutation PublishEvent($id: ID!) {
    publishEvent(id: $id) {
      _id
      name
      status
    }
  }
`;

export const STOP_EVENT_RECURRENCE = gql`
  mutation StopEventRecurrence($id: ID!) {
    stopEventRecurrence(id: $id) {
      _id
      recurrence {
        enabled
        intervalValue
        intervalUnit
      }
    }
  }
`;
